export const WeightHint = ({ grams, length, width, height }) => {
  const g = parseFloat(grams) || 0;
  const vol = (parseFloat(length) || 0) * (parseFloat(width) || 0) * (parseFloat(height) || 0) / 5000;
  const chargeable = Math.max(g / 1000, vol) || 0.5;
  const looksLikeKg = g > 0 && g < 10;
  return (
    <div className="mt-2 text-[11px] space-y-0.5" data-testid="weight-hint">
      {looksLikeKg && (
        <p className="text-red-600 font-medium" data-testid="weight-hint-kg-warning">
          {g} g looks like a kilogram value — enter grams (e.g. 250 for 250 g / 0.25 kg).
        </p>
      )}
      {g === 0 && vol === 0 && (
        <p className="text-amber-600" data-testid="weight-hint-estimated">No weight yet — shipping will be estimated at 0.5 kg per unit.</p>
      )}
      <p className="text-gray-500">
        Actual {(g / 1000).toFixed(3)} kg{vol > 0 && <> · Volumetric {vol.toFixed(3)} kg</>} · Chargeable <span className="font-medium text-gray-700">{chargeable.toFixed(3)} kg</span>
      </p>
    </div>
  );
};
